(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9693,2820],{

/***/ 79693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26628);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54407);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46066);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_10__);














var StroykaSlickBase = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(StroykaSlickBase, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(StroykaSlickBase);
    function StroykaSlickBase(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, StroykaSlickBase);
        var _this;
        _this = _super.call(this, props);
        _this.unsubscribeMedias = function() {};
        _this.originalSlickNext = function() {};
        _this.originalSlickPrev = function() {};
        _this.setRef = function(ref) {
            _this.element = ref;
        };
        _this.onMousedown = function(event) {
            var downX = event.screenX;
            var downY = event.screenY;
            var onMousemove = function(moveEvent) {
                var preventClick = _this.state.preventClick;
                if (preventClick) {
                    return;
                }
                var distance = Math.sqrt(Math.pow(Math.abs(downX - moveEvent.screenX), 2) + Math.pow(Math.abs(downY - moveEvent.screenY), 2));
                if (moveEvent.cancelable && distance > 3) {
                    moveEvent.preventDefault();
                }
                if (distance > 15) {
                    _this.setState({
                        preventClick: true
                    });
                }
            };
            var onMouseup = function() {
                _this.setState({
                    preventClick: false
                });
                document.removeEventListener("mousemove", onMousemove);
                document.removeEventListener("mouseup", onMouseup);
            };
            document.addEventListener("mousemove", onMousemove);
            document.addEventListener("mouseup", onMouseup);
        };
        _this.beforeChange = function(oldIndex, newIndex) {
            // @ts-ignore
            var beforeChange = _this.props.beforeChange;
            if (beforeChange) {
                beforeChange(oldIndex, newIndex);
            }
            setTimeout(function() {
                _this.setState({
                    activeSlides: _this.getActiveSlides(newIndex)
                });
            }, 0);
        };
        _this.setSlickRef = function(ref) {
            // @ts-ignore
            var _$forwardRef = _this.props.forwardRef;
            if (_$forwardRef) {
                _$forwardRef(ref);
            }
            if (ref && ref !== _this.slickRef) {
                _this.originalSlickNext = ref.slickNext;
                _this.originalSlickPrev = ref.slickPrev;
                ref.slickNext = _this.slickNext;
                ref.slickPrev = _this.slickPrev;
            }
            // @ts-ignore
            _this.slickRef = ref;
        };
        _this.slickNext = function() {
            // @ts-ignore
            var locale = _this.props.locale;
            // @ts-ignore
            var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
            if (direction === "rtl") {
                _this.originalSlickPrev();
            } else {
                _this.originalSlickNext();
            }
        };
        _this.slickPrev = function() {
            // @ts-ignore
            var locale = _this.props.locale;
            // @ts-ignore
            var direction = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale].direction;
            if (direction === "rtl") {
                _this.originalSlickNext();
            } else {
                _this.originalSlickPrev();
            }
        };
        _this.state = {
            preventClick: false,
            activeSlides: _this.getActiveSlides(_this.getStartPosition()),
            slidesToShow: null
        };
        return _this;
    }
    var _proto = StroykaSlickBase.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (!this.element) {
            return;
        }
        this.element.addEventListener("mousedown", this.onMousedown);
        if (this.slickRef) {
            this.slickRef.slickGoTo(this.getStartPosition(), true);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        // const {locale: prevLocale, children: prevChildren} = prevProps;
        var prevChildren = prevProps.children;
        var prevLocale = "en";
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[prevLocale];
        var prevDirection = language ? language.direction : "ltr";
        // @ts-ignore
        // const {locale: currLocale, children: currChildren} = this.props;
        var _props = this.props, currChildren = _props.children;
        var currLocale = "en";
        // @ts-ignore
        var _currLocale = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[currLocale], currDirection = _currLocale.direction;
        if (currDirection !== prevDirection && this.slickRef) {
            this.slickRef.slickGoTo(this.getStartPosition(), true);
        }
        if (currChildren !== prevChildren) {
            setTimeout(function() {
                _this.setState({
                    activeSlides: _this.getActiveSlides(_this.getStartPosition())
                });
            }, 0);
        }
        var prevResponsive = prevProps.responsive;
        // @ts-ignore
        var _props1 = this.props, currResponsive = _props1.responsive;
        if (currResponsive !== prevResponsive) {
            this.unsubscribeMedias();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeMedias();
        if (!this.element) {
            return;
        }
        this.element.removeEventListener("mousedown", this.onMousedown);
    };
    _proto.getSlidesCount = function getSlidesCount() {
        //@ts-ignore
        return react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(this.props.children).length;
    };
    _proto.getStartPosition = function getStartPosition() {
        // @ts-ignore
        var infinite = this.props.infinite;
        // @ts-ignore
        var _props = this.props, _locale = _props.locale, locale = _locale === void 0 ? "en" : _locale;
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale];
        var direction = language ? language.direction : "ltr";
        infinite = infinite === true || infinite === undefined;
        if (direction === "ltr") {
            return 0;
        }
        var slidesToShow = null;
        // const slidesCount = 3
        var slidesCount = this.getSlidesCount();
        if (!infinite) {
            // @ts-ignore
            return Math.max(0, slidesCount - slidesToShow);
        }
        // @ts-ignore
        return (Math.ceil(slidesCount / slidesToShow) - 1) * slidesToShow;
    };
    // @ts-ignore
    _proto.getActiveSlides = function getActiveSlides(currentIndex) {
        var slidesToShow = null;
        var activeSlides = [];
        var slidesCount = this.getSlidesCount();
        var firstSlide = Math.max(0, // @ts-ignore
        Math.min(slidesCount - slidesToShow, currentIndex));
        // @ts-ignore
        var lastSlide = Math.min(slidesCount, firstSlide + slidesToShow);
        for(var i = firstSlide; i < lastSlide; i += 1){
            activeSlides.push(i);
        }
        return activeSlides;
    };
    _proto.getSlidesToShow = function getSlidesToShow() {
        // @ts-ignore
        var _props = this.props, responsive = _props.responsive, slidesToShow = _props.slidesToShow;
        var result = slidesToShow || 1;
        if (responsive) {
            // @ts-ignore
            responsive.forEach(function(options) {
                var matches = matchMedia("(max-width: ".concat(options.breakpoint, "px)")).matches;
                if (matches && options.settings.slidesToShow) {
                    result = options.settings.slidesToShow;
                }
            });
        }
        return result;
    };
    _proto.createMedias = function createMedias() {
        var _this = this;
        // @ts-ignore
        var _props = this.props, responsive = _props.responsive, slidesToShow = _props.slidesToShow;
        if (responsive && responsive.length > 0) {
            // @ts-ignore
            var subscriptions = [];
            var createMedia = function(query, slidesToShow) {
                var media = matchMedia(query);
                var onChange = function() {
                    var matches = media.matches;
                    if (matches && slidesToShow) {
                        _this.setState(function() {
                            return {
                                slidesToShow: slidesToShow
                            };
                        });
                    }
                };
                if (media.addEventListener) {
                    media.addEventListener("change", onChange);
                } else {
                    media.addListener(onChange);
                }
                subscriptions.push(function() {
                    if (media.removeEventListener) {
                        media.removeEventListener("change", onChange);
                    } else {
                        media.removeListener(onChange);
                    }
                });
            };
            createMedia("(min-width: ".concat(responsive[0].breakpoint, ".02px)"), slidesToShow || 1);
            responsive.forEach(function(options, index) {
                var query = [
                    "(max-width: ".concat(options.breakpoint, "px)")
                ];
                if (responsive.length - 1 !== index) {
                    query.push("(min-width: ".concat(responsive[index + 1].breakpoint, ".02px)"));
                }
                createMedia(query.join(" and "), options.settings.slidesToShow);
            });
            this.unsubscribeMedias = function() {
                subscriptions.forEach(function(x) {
                    return x();
                });
            };
        }
    };
    _proto.render = function render() {
        // @ts-ignore
        var _props = this.props, children = _props.children, _$forwardRef = _props.forwardRef, locale = _props.locale, beforeChange = _props.beforeChange, autoplay = _props.autoplay, autoplaySpeed = _props.autoplaySpeed, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_props, [
            "children",
            "forwardRef",
            "locale",
            "beforeChange",
            "autoplay",
            "autoplaySpeed"
        ]);
        var _state = this.state, preventClick = _state.preventClick, activeSlides = _state.activeSlides, slidesToShow = _state.slidesToShow;
        // @ts-ignore
        var language = _i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale];
        var direction = language ? language.direction : "ltr";
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["slick-prevent-click"]), preventClick && (_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["slick-prevent-click--active"]));
        var reversedChildren = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
        if (direction === "rtl") {
            reversedChildren = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(children);
            reversedChildren.reverse();
        }
        reversedChildren.map(function(slide, index) {
            var slideClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()(activeSlides.includes(index) && (_shared_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["correct-slick-active"]));
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dir: direction,
                className: slideClasses,
                children: slide
            }, index);
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes,
            onMouseDown: this.onMousedown,
            ref: this.setRef,
            style: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, otherProps), {
                autoplay: autoplay,
                rtl: false,
                beforeChange: this.beforeChange,
                autoplaySpeed: autoplaySpeed,
                infinite: // @ts-ignore
                otherProps.infinite && react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children) > slidesToShow,
                // @ts-ignore
                ref: this.setSlickRef,
                children: reversedChildren
            }))
        });
    };
    return StroykaSlickBase;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var mapStateToProps = function(state) {
    return {
        locale: state.locale.code
    };
};
var StroykaSlick = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps)(StroykaSlickBase);
// @ts-ignore
// eslint-disable-next-line react/display-name
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StroykaSlick, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        forwardRef: ref
    }, props));
}));


/***/ }),

/***/ 54407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// application
var enMessages = __webpack_require__(82742);
var ruMessages = __webpack_require__(16495);
var hyMessages = __webpack_require__(24447);
/* harmony default export */ __webpack_exports__["Z"] = ({
    en: {
        messages: enMessages,
        direction: "ltr"
    },
    ru: {
        messages: ruMessages,
        direction: "ltr"
    },
    hy: {
        messages: hyMessages,
        direction: "ltr"
    }
});


/***/ }),

/***/ 12820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-success":"shared_text-success__b_GSc","text-danger":"shared_text-danger__uaRO3","product__prices":"shared_product__prices__CVW7b","color-lightgray":"shared_color-lightgray__tr4MM","product-card__new-price":"shared_product-card__new-price__Uh_wK","product-card__new-price_old_value":"shared_product-card__new-price_old_value__lZEg1","product-card__old-price":"shared_product-card__old-price__qVzw5","test":"shared_test__XJFgh","slick-prevent-click":"shared_slick-prevent-click__46Rz_","product-gallery__carousel":"shared_product-gallery__carousel__rweRi","slick-list":"shared_slick-list__Qm8q0","slick-track":"shared_slick-track__e1on5","product__gallery":"shared_product__gallery__2Qcoo","product-gallery__featured":"shared_product-gallery__featured__7qvkg","product-image__body":"shared_product-image__body___pMPQ","product-image":"shared_product-image__RGE_Z","product-gallery__zoom":"shared_product-gallery__zoom__zE4Rt","product-gallery__carousel-item":"shared_product-gallery__carousel-item__YOaGt","product-image--location--gallery":"shared_product-image--location--gallery__mX462","product-image__img":"shared_product-image__img__7FiK4","owl-carousel":"shared_owl-carousel__DZ_qV","owl-item":"shared_owl-item__1Ipyt","product-gallery__carousel-item--active":"shared_product-gallery__carousel-item--active__Y6uRZ","small-img-car_fms":"shared_small-img-car_fms__trqT1","product-small-img":"shared_product-small-img__19vI8","currency_value":"shared_currency_value__5IPjM","block-header":"shared_block-header__Y47R6","block-header__title":"shared_block-header__title__fNPSo","block-header__divider":"shared_block-header__divider__z_Ltc","block-header__groups-list":"shared_block-header__groups-list__Lcx3T","block-header__title__custom":"shared_block-header__title__custom__sD_wp","title-line-fms":"shared_title-line-fms__G_D1_","title-name-fms":"shared_title-name-fms__dTBlZ","block-header__group":"shared_block-header__group__wwwXx","block-header__group--active":"shared_block-header__group--active__Fl3KN","block-header__arrows-list":"shared_block-header__arrows-list__Acux7","block-header__arrow":"shared_block-header__arrow__IeFTb","block-header__arrow--left":"shared_block-header__arrow--left__UKyJW","block-header__arrow--right":"shared_block-header__arrow--right__KMu9G","breadcrumb":"shared_breadcrumb___jX19","input-number":"shared_input-number__mS_oj","minus_hide":"shared_minus_hide__G0BFC","input-number__input":"shared_input-number__input__pZxDP","input-number__sub":"shared_input-number__sub__8I6_b","input-number__add":"shared_input-number__add__0lk8a","form-control-sm":"shared_form-control-sm__fiyvR","product__quantity":"shared_product__quantity__j3dv_","cart-quantity-responsive":"shared_cart-quantity-responsive__5_4kx","page-header":"shared_page-header__36R5E","breadcrumb-item":"shared_breadcrumb-item__0qre7","breadcrumb-item-active":"shared_breadcrumb-item-active__V3KYS","page-header__breadcrumb":"shared_page-header__breadcrumb__i_Z7a","page-header__title":"shared_page-header__title__JaRFr","breadcrumb-arrow":"shared_breadcrumb-arrow__uQK9o","page-header__container":"shared_page-header__container__mEt_Q","pagination":"shared_pagination__bdXo7","sr-only":"shared_sr-only__9FqOD","page-link":"shared_page-link__CMUmq","page-link--with-arrow":"shared_page-link--with-arrow__c1IUc","page-link__arrow":"shared_page-link__arrow__mULrQ","page-link__arrow--left":"shared_page-link__arrow--left___61oN","page-link__arrow--right":"shared_page-link__arrow--right__k9sB2","page-item":"shared_page-item__dpA_F","page-item-disabled":"shared_page-item-disabled__DERIG","page-item-active":"shared_page-item-active__MPK7e","bottomNavigation-wrapper":"shared_bottomNavigation-wrapper__qch5s","indicatpr_area":"shared_indicatpr_area__8uOGn","bottom-nav-item--title":"shared_bottom-nav-item--title__vcuz0","bottom-nav-item--title-active":"shared_bottom-nav-item--title-active__XLHhd","local-item":"shared_local-item__lM6aT","local-item-active":"shared_local-item-active__SLCm2","active":"shared_active__9Ifpg","bottom-nav-item":"shared_bottom-nav-item__O_XHs","bottom-nav":"shared_bottom-nav__H2kJw","indicator__value":"shared_indicator__value__WOLbt","indicator":"shared_indicator__H_FQK","false":"shared_false___CPLZ","indicator__area":"shared_indicator__area__th4gv","mob_area":"shared_mob_area___TbbM","block-posts":"shared_block-posts___KdlJ","slick-slide":"shared_slick-slide__A6TQC","post-card":"shared_post-card__iG54_","block-posts--layout--list-sm":"shared_block-posts--layout--list-sm__U1MbP","post-card__image":"shared_post-card__image__7N_gj","post-card__name":"shared_post-card__name__mtEZ3","post-card__date":"shared_post-card__date__Vl_uC","post-card__category":"shared_post-card__category__tfnxa","post-card__content":"shared_post-card__content__WkHA7","post-card__read-more":"shared_post-card__read-more__8ZXB_","post-card__info":"shared_post-card__info__hGWgj","block-posts--layout--grid-nl":"shared_block-posts--layout--grid-nl__A6c3z","post-card__read-data":"shared_post-card__read-data__D4d0W","post-card--layout--related":"shared_post-card--layout--related__XefJD","post-card--layout--grid":"shared_post-card--layout--grid__e3_ld","post-card--size--lg":"shared_post-card--size--lg__x_1XA","post-card--layout--list":"shared_post-card--layout--list__wvqDN","post-card--size--nl":"shared_post-card--size--nl__AJ2H2","post-card--size--sm":"shared_post-card--size--sm__6Zwvl","social-links__list":"shared_social-links__list__dfW3w","social-links__item":"shared_social-links__item__7uXma","social-links__link":"shared_social-links__link__b_S9g","social-links--shape--circle":"shared_social-links--shape--circle__YFFEi","social-links--shape--rounded":"shared_social-links--shape--rounded__TT0YX","social-links__link--type--facebook":"shared_social-links__link--type--facebook__G719K","social-links__link--type--twitter":"shared_social-links__link--type--twitter__7ulYd","social-links__link--type--youtube":"shared_social-links__link--type--youtube__FWKHG","social-links__link--type--instagram":"shared_social-links__link--type--instagram___32Vy","social-links__link--type--rss":"shared_social-links__link--type--rss___vbZg","wishlist-circle":"shared_wishlist-circle__IHvkp","wishlist-icon-wrapper":"shared_wishlist-icon-wrapper__pW_9v","wishlist-circle-clicked":"shared_wishlist-circle-clicked__ZBHpI","inner-wishlist":"shared_inner-wishlist__S07T4","product-card__prices":"shared_product-card__prices__OXbim","uPsell-title":"shared_uPsell-title__TIb25","upsell-content":"shared_upsell-content__QoYrE","upsell_body":"shared_upsell_body__5qzyA","product__content":"shared_product__content__zHVz_","product__info":"shared_product__info__2JUdC","short_description_block":"shared_short_description_block__hIkfU","product-inner-description-title":"shared_product-inner-description-title__h9vAb","product__meta":"shared_product__meta__EwL40","product__sidebar":"shared_product__sidebar__O9bRJ","product__options":"shared_product__options__2X85W","product__actions":"shared_product__actions__dAK_0","no-thanks":"shared_no-thanks__G__wn","btn":"shared_btn__2IzVc","btn-orange":"shared_btn-orange__zc5e3","rounded-pills":"shared_rounded-pills__Z7qlr","product__name":"shared_product__name__QUTXW","ups-product__info":"shared_ups-product__info__W_YrR","product__actions-item--addToCart":"shared_product__actions-item--addToCart__dHUJi","item_overlay":"shared_item_overlay__qz1Am","product-card__image":"shared_product-card__image__IroED","product-image__default-fms":"shared_product-image__default-fms__0xjYL","cross__prods":"shared_cross__prods__xJAFI"};

/***/ }),

/***/ 82742:
/***/ (function(module) {

"use strict";
module.exports = {};

/***/ }),

/***/ 24447:
/***/ (function(module) {

"use strict";
module.exports = {};

/***/ }),

/***/ 16495:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"topBar.phone1":"374 93 99-10-93","topBar.phone2":"+374 10 35-11-00","topBar.storeLocation":"Магазин","topBar.trackOrder":"Статус заказа","topBar.blog":"Блог","topBar.myAccount":"Аккаунт","topBar.currency":"Валюта","topBar.language":"Язык","topBar.login":"Մուտք","topBar.forgot":"Մոռացե՞լ եք գաղտնաբառը","header.phoneLabel":"Звонок бесплатный","header.phone":"(800) 060-0730"}');

/***/ })

}]);